import { create } from 'zustand'
import axios from 'axios'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

import { CRUDBaseStore } from './Base/CRUD'

interface MaintenanceStore extends CRUDBaseStore {
  selectedId: any
  setSelectedId: (selectedId: any) => void
  getOne: (id: number) => Promise<{ success: boolean; data: any }>
}

export const API_SLUG = 'maintenance'

export const INITIAL_STATE = {
  id: 10,
  saleOrderId: '',
  jobStatus: '',
  machineTitle: '',
  issueTitle: '',
  issueCategory: '',
  // '2023-09-16T10:55:48.5221994'
  startPeriod: null,
  // '2023-09-16T10:55:48.5221994'
  endPeriod: null,
  problemReportBy: '',
  // '2023-09-16T10:55:48.5221994'
  problemReportAt: null,
  remark: '',
  // '2023-09-16T10:55:48.5221994'
  createdAt: null,
  // '2023-09-16T10:55:48.5221994'
  updatedAt: null,
  createdByUserId: '',
  createdByUser: {
    // id: '510ddbbb-0694-435f-da68-08dba62fbbc8',
    // username: 'tester',
    // fullName: 'tester',
    // position: null,
    // permissions: null,
    // permissionUsers: [],
    // mobile: null,
    // isActive: true,
    // createdAt: '2023-08-26T19:26:54.7051179',
    // verifyAt: null,
    // lastLoginAt: null,
  },
  projectId: 0,
  project: null,
}

export const useMaintenanceStore = create<MaintenanceStore>(set => ({
  data: [],
  selected: INITIAL_STATE,
  selectedId: undefined,
  loading: false,
  error: undefined,
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  setError: (error: any) => {
    set({ error })
  },
  setSelected: (selected: any) => {
    set({ selected })
  },
  setSelectedId: (selectedId: any) => {
    set({ selectedId })
  },
  getAll: async (filter: any) => {
    set({ loading: true })
    const finaleFilter = cleanParamsFilter(filter)

    return axios
      .get(`/${API_SLUG}`, { params: finaleFilter })
      .then(res => {
        set({ data: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getOne: async id => {
    set({ loading: true })

    return axios
      .get(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ selected: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  create: async (data: any) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    return axios
      .post(`/${API_SLUG}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  edit: async (id, data) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    return axios
      .patch(`/${API_SLUG}/${id}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  delete: async id => {
    set({ loading: true })
    return axios
      .delete(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  clearState: () => {
    set({
      data: [],
      loading: false,
      error: undefined,
      selected: INITIAL_STATE,
      selectedId: undefined,
    })
  },
}))
